import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { userProductRoleSchema } from '../schemas/user-product-role.schema';

/**
 * Get a paginated list of users with roles for the onboarding applications
 * @param accountId Id of Account
 * @param params Paged Collection Params
 * @returns Paginated list of useres with roles
 */
export function getProductsAccountsUsers(
  this: unknown,
  accountId: number,
  params?: PagedCollectionParams
) {
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).productsUrl
      }/accounts/${encodeURIComponent(accountId)}/users${
        params ? `?${params.urlParams}` : ''
      }`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(createPagedCollectionSchema(userProductRoleSchema)));
}
